import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/library/icons/interface-search.svg
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 256 256"
};
function render(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "m229.66 218.34-50.07-50.06a88.11 88.11 0 1 0-11.31 11.31l50.06 50.07a8 8 0 0 0 11.32-11.32M40 112a72 72 0 1 1 72 72 72.08 72.08 0 0 1-72-72" }, null, -1)])]);
}
var interface_search_default = { render };
//#endregion
export { interface_search_default as default, render };

//# sourceMappingURL=interface-search.svg.js.map